export { default } from './HorizontalBarChart.component';
export type { HorizontalBarChartProps } from './HorizontalBarChart.component';
